import LoadingSpinner from '../components/LoadingSpinner.js'
import CurrentBalance from '../components/CurrentBalance.js';
import BalanceUp from '../components/BalanceUp.js';
export default class ProfilePage{
    constructor(app, telegram, params){
        this.app = app;
        this.telegram = telegram;
        this.params = params;
    }

    async mount(container) {
        this.container = container;
        this.render();
    }

    render(){
        this.container.innerHTML = `
            <div id="profile-page" class="profile">
                <h2 class="page-header-title">Профиль</h2>  
                <div id="loading"></div>
                <div id="price"></div>
                <div id="balance-up"></div>
                <div class="support">
                    <a href="https://t.me/eVeV27" class="support-link" target="_blank">
                        <i class="fab fa-telegram"></i>
                        <span>Поддержка в Telegram</span>
                        <i class="fas fa-external-link-alt"></i>
                    </a>
                    <div class="support-text">
                        Есть вопросы по оплате или работе бота? Напишите нам!
                    </div>
                </div>
            </div>
        `;
        this.renderBalance();
        this.renderBalanceUp();
    }

    async renderBalance(){        
        const profileElement = this.container.querySelector('#price');
        const balanceJSON = await this.app.api.getBalanceAndPrice();
        const balanceComponent = new CurrentBalance({
            currentBalance: balanceJSON.currentBalance,
            messagePrice: balanceJSON.messagePrice,
            imagePrice: balanceJSON.imagePrice
        });

        balanceComponent.render(profileElement);
    }

    async renderBalanceUp(){

        this.app.telegram.tg.BackButton.show();
        // this.app.pathStory.push('/stories');

        const clickHandler = (data)=> {
            this.app.api.upBalance(data);
            this.app.telegram.close();
        }
        
        const profileElement = this.container.querySelector('#balance-up');
        const balanceUpJSON = await this.app.api.getBalanceUp();
        const balanceUpComponent = new BalanceUp({
            priceList: balanceUpJSON,
            clickHandler: clickHandler
        });

        balanceUpComponent.render(profileElement);
    }
}